export interface ApplicationForm {
  firstName: string
  lastName: string
  email: string
  phone: string
  okToText: boolean
  primarySeat: string
  otherSeats: string[]
  location: string
  timezone: string
  workSetup: string
  earliestStart: string
  yearsExperience: string
  portfolioUrl: string
  answerResult: string
  answerDetail: string
  answerPushback: string
  answerThinking: string
  compensation: string
  howDidYouHear: string
}

export type FieldErrors = Partial<
  Record<keyof ApplicationForm | 'resume', string>
>

export interface StepProps {
  form: ApplicationForm
  errors: FieldErrors
  onChange: <K extends keyof ApplicationForm>(
    field: K,
    value: ApplicationForm[K],
  ) => void
}

export const EMPTY_APPLICATION: ApplicationForm = {
  firstName: '',
  lastName: '',
  email: '',
  phone: '',
  okToText: true,
  primarySeat: '',
  otherSeats: [],
  location: '',
  timezone: '',
  workSetup: '',
  earliestStart: '',
  yearsExperience: '',
  portfolioUrl: '',
  answerResult: '',
  answerDetail: '',
  answerPushback: '',
  answerThinking: '',
  compensation: '',
  howDidYouHear: '',
}
